module.exports = __webpack_public_path__ + "static/preview-549c63d44ea6c0078746d1f505e0e03c.jpg";